import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Popover } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import crmTaskService from '../../service/crmTask.service';
import companyService from '../../service/company.service';
import CrmTaskDialog from '../CrmTask/CrmTaskDialog';
import { GridToolbarContainer } from '@mui/x-data-grid-premium';
import { dataGridPremiumColumns } from '../../utils/helper';
import AttachmentIcon from '@mui/icons-material/Attachment';

function EditToolbar(props) {
  const { handlePopoverOpen, disabled } = props;
  return (
    <GridToolbarContainer>
      <ButtonUI
        text="Új felvitel"
        className="bg-success mb-1"
        size="sm"
        onClick={handlePopoverOpen}
        disabled={disabled}
      />
    </GridToolbarContainer>
  );
}

const CompanyHistory = ({ selectedValues, setSelectedValues, disabled, setRefetchTable, autocompleteOptions }) => {
  const [selectedRow, setSelectedRow] = useState({});
  const [rows, setRows] = useState([]);
  const [isCrmTaskDialogOpen, setIsCrmTaskDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [taskChanged, setTaskChanged] = useState(false);

  const open = Boolean(anchorEl);

  useEffect(() => {
    if (selectedValues.histories && selectedValues.histories.length > 0) {
      setRows(selectedValues.histories);
    } else {
      setRows([]);
    }
  }, [selectedValues.histories]);

  useEffect(() => {
    if (taskChanged) {
      getCompanyById();
      setRefetchTable(true);
    }
  }, [taskChanged]);

  const getCompanyById = () => {
    if (selectedValues.id) {
      companyService.getCompanyById(selectedValues.id).then((data) => {
        setSelectedValues(data);
        setTaskChanged(false);
      });
    }
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (row) => {
    if (row.taskType === 'Esemény') {
      getCrmTaskById(row);
    }
  };

  const getCrmTaskById = (row) => {
    crmTaskService.getTaskById(row.id).then((data) => {
      setSelectedRow(data);
      setIsCrmTaskDialogOpen(true);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'startDate',
      headerName: 'Kezdő időpont',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.startDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.startDate).format('YYYY.MM.DD HH:mm');
      },
    },
    {
      field: 'taskType',
      headerName: 'Objektum',
      type: 'string',
    },
    {
      field: 'name',
      headerName: 'Feladat neve',
      type: 'string',
    },
    {
      field: 'type',
      headerName: 'Típus',
      type: 'string',
    },
    {
      field: 'createdBy',
      headerName: 'Tulajdonos',
      type: 'string',
    },
    {
      field: 'companyContactId',
      headerName: 'Kapcsolattartó',
      type: 'singleSelect',
      renderCell: (params) => {
        return params.row.companyContact?.name;
      },
    },
    {
      field: 'contactPhoneNumber',
      headerName: 'Kapcs.tartó telefonszáma',
      type: 'string',
    },
    {
      field: 'contactEmail',
      headerName: 'Kapcs.tartó email címe',
      type: 'string',
    },
    {
      field: 'more',
      headerName: 'Megtekint',
      type: 'actions',
      renderCell: (params) => {
        return (
          params.row.taskType !== 'Cég' && (
            <RemoveRedEyeIcon color="black" onClick={() => handleOpen(params.row)} sx={{ cursor: 'pointer' }} />
          )
        );
      },
    },
    {
      field: 'hasAttachment',
      headerName: 'Csatolmány',
      type: 'string',
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        return params.row?.hasAttachment && <AttachmentIcon color="black" />;
      },
    },
  ]);

  return (
    <div className="max-h-[400px] overflow-y-scroll overflow-x-hidden custom-scrollbar -mt-3">
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        <div className="p-4 flex gap-2">
          <ButtonUI text="Új esemény" className="bg-warning" size="sm" onClick={() => setIsCrmTaskDialogOpen(true)} />
        </div>
      </Popover>
      <DatagridPremiumUi
        height={400}
        datagridIdentifier={DataGridIdentifiers.companyHistory}
        rows={rows}
        rowCount={rows?.length}
        columns={[...columns]}
        disableRowSelectionOnClick={!disabled}
        getRowHeight={() => 'auto'}
        getRowId={(row) => `${row.id}_${row.name}`}
        slots={{
          toolbar: EditToolbar,
        }}
        slotProps={{
          toolbar: {
            handlePopoverOpen,
            disabled,
          },
        }}
      />
      <CrmTaskDialog
        open={isCrmTaskDialogOpen}
        handleClose={() => setIsCrmTaskDialogOpen(false)}
        task={selectedRow}
        setSelectedRow={setSelectedRow}
        setTaskChanged={setTaskChanged}
        selectedValues={selectedValues}
        parentData={{ companyId: selectedValues.id }}
      />
    </div>
  );
};

export default CompanyHistory;
